import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Button, Form, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { PLATFORM_FIELD, PlatformDataType } from "src/interfaces/Platform.interface";
import { AttributeType, MORE_MAPPING_FORM_DATA, MoreFieldMappingItem, PLATFORM_FIELD_DATA, RECIPE_FORM_DATA, TITLE_DESCRIPTION, PRICE_TEMPLATE_FIELD, OPTION_TYPE, PRICE_ADJUSTMENT_TYPE } from "src/interfaces/Template.interface";
import { getPlatformFieldsAsync } from "src/redux/actions/productActions";
import {
  createMoreMappingAsync, createRecipeAsync, getPlatformChildFieldDataCategoriesAsync, getPlatformFieldDataAttributesAsync, getPlatformParentFieldDataCategoriesAsync,
  getShortCodeAsync, postFieldDataAttributesAsync, savePlatformTitleDescriptionTemplateAsync
} from "src/redux/actions/templateAndPricingActions";
import { useAppDispatch, useAppSelector } from "src/redux/storeHooks";
import InputAttributes from "../InputAttributes";
import CopyToClipboard from "react-copy-to-clipboard";
import { prepareDescriptionValueForSave } from "src/utils/CustomEditor";
import { limitDescriptionValue } from "src/utils/descriptionHtmlSource";
import DescriptionHtmlEditor from "../DescriptionHtmlEditor";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import { accessSessionTokenKeyName, loggedInAdminAccessToken, LANGUAGES_ENUM } from 'src/utils/constants';
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import InputAttributes2 from "../InputAttributes2";
import { toast } from "react-toastify";
import { Formik, FormikProps } from "formik";
import { getPlatformPriceAsync, savePlatformPriceAsync } from "src/redux/actions/productPricingAction";
import { useUserHavingWriteAccess } from "src/utils/useUserHavingWriteAccess";
import Select from "react-select";
import RecipeRuleItem from "../RecipeRuleItem";
import useAppToast from "src/hooks/useAppToast";
import { useProgressiveLoadingMessage } from "src/marketConnect/helpers";
import { usePermission } from "src/hooks/usePermission";
import { fetchSourcePlatformAsync } from "src/redux/actions/platformActions";
import CategoryMappingEngine, { CategoryMappingChangeData } from '../CategoryMappingEngine';
import { fetchPlatformLimitations } from 'src/utils/platformLimitations';
import { usePriceModifierFields, PriceRuleFormValue, generateDefaultPriceRules } from '../hooks/usePriceModifierFields';
import { getPriceRuleValidationError, blockNegativeNumberInput, sanitizeNonNegativeNumericInput } from "../../utils/priceModifierValidation";
import {
  buildMoreMappingPayload,
  buildMoreMappingSaveEntries,
  buildOtherTemplateLinks,
  getMissingMandatoryMappingField,
} from "../../utils/quicklistMoreMappingUtils";
import {
  formatLegacyRepricingMagnitudeForInput,
  resolveQuicklistPricePayload,
} from "../../utils/quicklistPriceModifierUtils";
import { DynamicPriceModifierRule } from '../DynamicPriceModifierRule';
interface CreateQuickListTabProps {
  platformId: number | undefined;
  selectedSecondaryPlatform: PlatformDataType | null;
  currentActivePlatform: number | undefined
}
type CategoryOption = {
  label: string
  value: string
}

const MANDATORY_MAPPING_FIELDS = [
  'WHEN_MADE', 
  'WHO_MADE', 
  'READ_LINE_STATE', 
  'RETURN_POLICY', 
  'SHIPPING_PROFILE'
];

const CreateQuickListTab: React.FC<CreateQuickListTabProps> = ({ platformId, selectedSecondaryPlatform, currentActivePlatform }) => {
  const dispatch = useAppDispatch();
  const { isRead, isWrite, isDelete } = usePermission();
  const { mainStoreData, erpStoreData, omsStoreData, accountingStoreData, shippingStoreData, ticketStoreData, fetchedSourcePlatformData, fetchedConnectedPlatformData } = useAppSelector((state) => state.fetchConnectedPlatform) || {}
  const apiSource = fetchedSourcePlatformData?.source_platform
  const sourceStore = apiSource?.id
    ? apiSource
    : mainStoreData ?? omsStoreData ?? erpStoreData ?? accountingStoreData ?? shippingStoreData ?? null
  const { isUserHavingWriteAccess } = useUserHavingWriteAccess();
  const { warningToast, successToast } = useAppToast();
  const generateRandomRuleName = () => {
    const randomNum = Math.floor(100000 + Math.random() * 900000); // 6-digit random number
    return `QuickRule${randomNum}`;
  };
  const [ruleName, setRuleName] = useState('');
  const finalRuleName = ruleName.trim() || generateRandomRuleName();
  const [isSaving, setIsSaving] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(false);
  const isRequired = selectedSecondaryPlatform?.isRequired;
  const [openAddNewAttributeValueModal, setOpenAddNewAttributeValueModal] = useState<boolean>(false);
  // ΓöÇΓöÇ engine integration state ΓöÇΓöÇ
  const [engineState, setEngineState] = useState<CategoryMappingChangeData>({
    categoryId: null,
    categoryPath: '',
    isLeafCategory: false,
    showAttributes: false,
    isAttributeLoading: false,
  })
  const [engineKey, setEngineKey] = useState(0)
  const [platformLimitations, setPlatformLimitations] = useState<{
    title: { min: number | null; max: number | null; info: string | null }
    description: { min: number | null; max: number | null; info: string | null }
  }>({
    title: { min: null, max: null, info: null },
    description: { min: null, max: null, info: null },
  })

  const { priceTemplateFields, isLoading: priceFieldsLoading } = usePriceModifierFields({
    platformId: platformId,
    enabled: platformId === currentActivePlatform
  });


  const resetAll = () => {
    // Reset React states
    setTitleInput("");
    setEditorData("");
    setDescriptionHtmlSource(false);
    setPriceAdjustmentType("increase");
    setRepricing({ type: "FLAT", value: null });
    setPriceRules(priceTemplateFields.length > 0 ? generateDefaultPriceRules(priceTemplateFields) : []);
    setSelectedAttributes([]);

    setOpenTitleAdvanceConfig(false);
    setTitleAdvanceSetting({
      isRemoveHtml: false,
      isTranslate: false,
      translate_language: "",
      isRephrasing: false,
      rephrasing_limit: "",
    });

    setCopyMarkup({});
    setButtonString("");

    setMoreFieldMappingData([]);
    setShowMoreMapping(false);

    setEngineKey((prev) => prev + 1);

    // Reset Formik form if available
    if (formikRef?.current) {
      formikRef.current.resetForm();
    }
  };

  useEffect(() => {
    resetAll();
  }, [currentActivePlatform, selectedSecondaryPlatform]);

  // ---------------------------------------------------------------------------------------------------------------
  const [titleInput, setTitleInput] = useState('')
  const [editorData, setEditorData] = useState('')
  const [descriptionHtmlSource, setDescriptionHtmlSource] = useState(false)
  const [tagsInput, setTagsInput] = useState('')
  const [skuInput, setSkuInput] = useState('')
  const [showIsDefault, setShowIsDefault] = useState(false)
  const [shortCode, setShortCode] = useState<any[]>([])
  const [shortCodeVisibility, setShortCodeVisibility] = useState({
    name: false,
    title: false,
    tags: false,
    sku: false,
    description: false,
  })
  const [copyMarkup, setCopyMarkup] = useState<{ [key: string]: boolean }>({})
  const [buttonString, setButtonString] = useState('')
  const [titleAdvanceSetting, setTitleAdvanceSetting] = useState({
    isRemoveHtml: false,
    isTranslate: false,
    translate_language: '',
    isRephrasing: false,
    rephrasing_limit: '',
  })
  const [descriptionAdvanceSetting, setDescriptionAdvanceSetting] = useState({
    isRemoveHtml: false,
    isTranslate: false,
    translate_language: '',
    isRephrasing: false,
    rephrasing_limit: '',
  })
  const [openTitleAdvanceConfig, setOpenTitleAdvanceConfig] = useState(false)
  const [openDescriptionAdvanceConfig, setOpenDescriptionAdvanceConfig] = useState(false)
  const { customFields, customHasMore, customLoading, customPage } = useSelector(
    (state: any) => state.customFieldsSlice || {}
  )
  const customItem = customFields?.length > 0

  const descriptionLimit = platformLimitations.description.max
  const remainingDescriptionCharacters =
    descriptionLimit && descriptionLimit > 0
      ? Math.max(descriptionLimit - editorData.length, 0)
      : 0

  // --- Handlers ---
  const handleDescriptionChange = (value: string, options?: { htmlSource?: boolean }) => {
    const htmlSource = options?.htmlSource ?? descriptionHtmlSource
    if (options?.htmlSource) {
      setDescriptionHtmlSource(true)
    }
    setEditorData(limitDescriptionValue(value, descriptionLimit, htmlSource))
  }

  const toggleShortCodeVisibility = (input: string) => {
    setShortCodeVisibility((prev) => ({ ...prev, [input]: !prev[input] }))
  }

  const handleCopyMarkup = (data: string, identifier: string) => {
    setCopyMarkup((prev) => ({ ...prev, [identifier]: true }))
    setButtonString(data)
    setTimeout(() => {
      setCopyMarkup((prev) => ({ ...prev, [identifier]: false }))
      setButtonString('')
    }, 1000)
  }

  const handleShortCode = async (input: string) => {
    try {
      const response = await dispatch(getShortCodeAsync({ shortcode_type: 'PRODUCT_SC', search_string: '' }))
      if (response.payload) {
        setShortCode(response.payload.results)
        toggleShortCodeVisibility(input)
      }
    } catch (err) {
      console.error('Error fetching shortcodes', err)
    }
  }

  const closeModal = () => {
    // setOpenAddNewAttributeValueModal(false);
  }

  const fetchSourcePlatform = () => {
    dispatch(fetchSourcePlatformAsync())
  }

  useEffect(() => {
    if (platformId === currentActivePlatform) {
      fetchSourcePlatform();
      handleShortCode('description')
      handleShortCode('title')
    }
  }, [platformId, currentActivePlatform]);

  useEffect(() => {
    const loadPlatformLimitations = async () => {
      const platformCode =
        selectedSecondaryPlatform?.platform_info?.name ?? selectedSecondaryPlatform?.code
      if (!platformCode) return

      try {
        const next = await fetchPlatformLimitations(platformCode)
        setPlatformLimitations(next)
      } catch (error) {
        console.error('Failed to fetch platform limitations', error)
      }
    }

    loadPlatformLimitations()
  }, [selectedSecondaryPlatform])
  const renderCustomFieldDropdown = (sectionKey: string) => {
    if (!customFields?.length) return null;

    const handleDropdownToggle = (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      const menu = e.currentTarget.nextElementSibling as HTMLElement;
      menu.classList.toggle("d-none");
    };

    const handleItemClick = (
      e: React.MouseEvent<HTMLDivElement>,
      fieldName: string
    ) => {
      e.stopPropagation();
      navigator.clipboard.writeText(`[${fieldName}]`);
      handleCopyMarkup(fieldName, sectionKey);

      const menu = e.currentTarget.parentElement as HTMLElement;
      menu.classList.remove("d-none");
      setTimeout(() => menu.classList.add("d-none"), 1000);
    };

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
      const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
      const atBottom = scrollHeight - scrollTop <= clientHeight + 10;

      if (atBottom && customHasMore && !customLoading && sourceStore?.id) {
        dispatch(
          getPlatformFieldsAsync({
            platformId: sourceStore.id!,
            otherParams: {
              field_type: "CUSTOM",
              owner: "PRODUCT",
              includeLocalFields: false,
              limit: 100,
              page: customPage + 1,
            },
          })
        );
      }
    };

    return (
      <div
        className="d-inline-block m-2 position-relative"
        style={{ width: "130px" }}
      >
        {/* Dropdown Button */}
        <div
          className="rounded text-primary fs-sm-8 px-3 py-1 bg-white d-flex justify-content-between align-items-center"
          style={{
            cursor: "pointer",
            userSelect: "none",
            border: "1px solid #1976d2",
          }}
          onClick={handleDropdownToggle}
        >
          CUSTOM_FIELDS
          <span className="text-primary ms-2">&#9662;</span>
        </div>

        {/* Dropdown Menu */}
        <div
          className="d-none position-absolute bg-white rounded  mt-1"
          style={{
            zIndex: 999,
            width: "130px",
            maxHeight: "170px",
            overflowY: "auto",
            border: "1px solid #1976d2",
          }}
          onClick={(e) => e.stopPropagation()}
          onScroll={handleScroll}
        >
          {customFields.map((item) => {
            const isCopied =
              copyMarkup[sectionKey] && buttonString === item.display_name;
            return (
              <div
                key={item.id}
                onClick={(e) => handleItemClick(e, item.display_name)}
                className={`px-3 py-1 d-flex align-items-center justify-content-between fs-sm-8 ${isCopied
                  ? "bg-success text-white"
                  : "text-primary bg-white hover:"
                  }`}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid #eee",
                  transition: "background-color 0.3s ease",
                }}
              >
                <span>{isCopied ? "Copied!" : `[${item.display_name}]`}</span>
                <FontAwesomeIcon
                  icon={faCopy}
                  color={isCopied ? "white" : "#1976d2"}
                  className="ms-2"
                  style={{ flexShrink: 0 }}
                />
              </div>
            );
          })}

          {customLoading && (
            <div className="text-center py-2 text-secondary small">
              Loading...
            </div>
          )}
        </div>
      </div>
    );
  };

  // ---------------------------------------------------------------------------------------------------------------
  // Price Logic State & Functions

  const mappingPlatformId = sourceStore?.id ?? null;
  const [priceAdjustmentType, setPriceAdjustmentType] = useState<string>("decrease");
  const [repricing, setRepricing] = useState<{ type: string; value: number | null }>({
    type: "FLAT",
    value: null,
  });
  const [priceRules, setPriceRules] = useState<PriceRuleFormValue[]>([]);
  const [priceNativeFields, setPriceNativeFields] = useState<PLATFORM_FIELD_DATA[]>([]);
  const [priceCustomFields, setPriceCustomFields] = useState<PLATFORM_FIELD_DATA[]>([]);
  const [mappingFieldsLoading, setMappingFieldsLoading] = useState(false);
  const [loadedFieldTypes, setLoadedFieldTypes] = useState({ NATIVE: false, CUSTOM: false });
  const loadingFieldTypesRef = useRef({ NATIVE: false, CUSTOM: false });

  useEffect(() => {
    setPriceRules(priceTemplateFields.length > 0 ? generateDefaultPriceRules(priceTemplateFields) : []);
  }, [priceTemplateFields]);

  const loadPlatformFieldOptions = useCallback(
    async (option: OPTION_TYPE) => {
      if (option === 'DEFAULT' || !mappingPlatformId) return;
      const fieldKey = option === 'CUSTOM' ? 'CUSTOM' : 'NATIVE';
      if (fieldKey === 'NATIVE' && (priceNativeFields.length || loadedFieldTypes.NATIVE)) return;
      if (fieldKey === 'CUSTOM' && (priceCustomFields.length || loadedFieldTypes.CUSTOM)) return;
      if (loadingFieldTypesRef.current[fieldKey]) return;
      loadingFieldTypesRef.current = { ...loadingFieldTypesRef.current, [fieldKey]: true };
      setMappingFieldsLoading(true);
      try {
        const response = await dispatch(
          getPlatformFieldsAsync({
            platformId: mappingPlatformId,
            otherParams: {
              field_type: fieldKey,
              includeLocalFields: fieldKey === 'NATIVE',
              owner: 'PRODUCT',
            },
          })
        );
        if (fieldKey === 'NATIVE') {
          setPriceNativeFields(response.payload);
        } else {
          setPriceCustomFields(response.payload);
        }
      } catch (err) {
        console.error('Error loading mapping options', err);
      } finally {
        setMappingFieldsLoading(false);
        loadingFieldTypesRef.current = { ...loadingFieldTypesRef.current, [fieldKey]: false };
        setLoadedFieldTypes((prev) => ({ ...prev, [fieldKey]: true }));
      }
    },
    [mappingPlatformId, priceNativeFields.length, priceCustomFields.length, loadedFieldTypes, dispatch]
  );

  const handleMappingOptionChange = async (rowIndex: number, option: OPTION_TYPE) => {
    setPriceRules(prev => {
      const updated = [...prev];
      updated[rowIndex] = { ...updated[rowIndex], mappingOption: option, defaultValue: '', mappedField: '' };
      return updated;
    });
    await loadPlatformFieldOptions(option);
  };

  const handlePriceRuleChange = (index: number, field: keyof PriceRuleFormValue, value: any) => {
    setPriceRules(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      if (field === 'adjustmentType' && value === 'NO_CHANGE') {
        updated[index].adjustmentValue = '';
      }
      return updated;
    });
  };

  const handleAdjustmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const type = e.target.value;
    const magnitude =
      repricing.value != null && Number.isFinite(repricing.value)
        ? Math.abs(repricing.value)
        : null;
    const newValue =
      magnitude == null
        ? null
        : type === "decrease"
          ? -magnitude
          : magnitude;
    setRepricing({ ...repricing, value: newValue });
    setPriceAdjustmentType(type);
  };
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizeNonNegativeNumericInput(e.target.value);
    if (sanitized === '') {
      setRepricing({ ...repricing, value: null });
      return;
    }
    const val = Number(sanitized);
    if (!Number.isFinite(val)) return;
    setRepricing({
      ...repricing,
      value: priceAdjustmentType === "decrease" ? -Math.abs(val) : Math.abs(val),
    });
  };
  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRepricing({ ...repricing, type: e.target.value });
  };
  // --------------------------------------------------------------------------------------------------------------------------
  // Category Section State & functions 
  const [isLeafCategory, setIsLeafCategory] = useState(false);
  const [showAttributes, setShowAttributes] = useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState<any[]>([]);
  const [attributesInUpdateCase, setAttributesInUpdateCase] = useState(null);

  // ------------------------------------------------------------------------------
  // More Mapping filed Section
  const [mappingLoading, setMappingLoading] = useState(false);
  const [showMoreMapping, setShowMoreMapping] = useState(false);
  const [moreFieldMappingData, setMoreFieldMappingData] = useState<MoreFieldMappingItem[]>([]);
  useEffect(() => {
    if (platformId === currentActivePlatform && selectedSecondaryPlatform?.id) {
      callFieldMapping(selectedSecondaryPlatform);
    }
  }, [currentActivePlatform]);

  const callFieldMapping = (item: PlatformDataType) => {
    setMappingLoading(true);
    setOtherTemplateFieldLoader(true);

    if (item.id) {
      dispatch(
        getPlatformFieldsAsync({
          platformId: item.id,
          otherParams: { field_code: '', allowMapViaTemplate: true, owner: 'PRODUCT' },
        })
      ).then((response) => {
        if (response?.payload?.length) {
          setMappingLoading(false);
          setShowMoreMapping(true);
          setMoreFieldMappingData(response.payload);
          setOtherTemplateFieldData(response.payload);
        } else {
          setMappingLoading(false);
          // toast.warning('No additional rule found');
        }
        setOtherTemplateFieldLoader(false);
      }).catch((err) => {
        setMappingLoading(false);
        setOtherTemplateFieldLoader(false);
        toast.error('Error fetching mapping data');
      });
    }
  };
  // ------------------------------------------------------------------------------------------------
  // Plan Section States and functionality
  const [templateDataLoading, setTemplateDataLoading] = useState(false)
  const [platformNativeFields, setPlatformNativeFields] = useState<PLATFORM_FIELD[] | []>([])
  const [platformCustomFields, setPlatformCustomFields] = useState<PLATFORM_FIELD[] | []>([])
  const [otherTemplateFieldLoader, setOtherTemplateFieldLoader] = useState(false);
  const [otherTemplateFieldData, setOtherTemplateFieldData] = useState([]);
  const [selectedRowsForDeletion, setSelectedRowsForDeletion] = useState<(number | null)[]>([]);

  const initialValue1: RECIPE_FORM_DATA = {
    name: '',
    selectedPricingTemplate: '',
    selectedTitleDescriptionTemplate: '',
    selectedCategoryTemplate: '',
    dataConjunction: 'OR',
    productRecipes: [
      {
        id: null,
        checkConjunction: 'OR',
        checkOperator: 'CONTAINS',
        checkPlatformField: platformNativeFields[0]?.id ? platformNativeFields[0]?.id + '' : '',
        checkValue: '',
      },
    ],
    other_templates: [],
  };

  const checkFormField = platformNativeFields[0]?.id + '';
  const isQuickTab = true;
  const formikRef = useRef<any>(null);
  const normalizePlatformFields = (payload: any): PLATFORM_FIELD[] => {
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.results)) return payload.results
    return []
  }

  useEffect(() => {
    if (!sourceStore?.id || platformId !== currentActivePlatform) return;
    setTemplateDataLoading(true);

    const fetchPlatformFields = async () => {
      try {
        // Fetch CUSTOM and NATIVE fields in parallel ΓÇö both are independent requests.
        // Using Promise.all() halves the loader time compared to sequential awaits.
        const [customResponse, nativeResponse]: any[] = await Promise.all([
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStore.id!,
              otherParams: {
                field_type: 'CUSTOM',
                owner: 'PRODUCT',
                includeLocalFields: false,
                limit: 100,
                page: 1,
              },
            })
          ),
          dispatch(
            getPlatformFieldsAsync({
              platformId: sourceStore.id!,
              otherParams: {
                field_type: 'NATIVE',
                owner: 'PRODUCT',
                includeLocalFields: true,
                limit: 100,
                page: 1,
              },
            })
          ),
        ]);

        setPlatformCustomFields(normalizePlatformFields(customResponse?.payload));
        setPlatformNativeFields(normalizePlatformFields(nativeResponse?.payload));
      } catch (error) {
        console.error("Error fetching platform fields:", error);
      } finally {
        setTemplateDataLoading(false);
      }
    };

    fetchPlatformFields();

    // Call other mapping function removed as it is now handled by callFieldMapping
  }, [currentActivePlatform, sourceStore?.id, platformId]);

  const selectOptionFormat = (options) => {
    const format: CategoryOption[] = options.map((cat) => ({
      value: cat.id,
      label: cat.name,
    }))
    return format
  }

  // ------------------------------------------------------------------------------
  const resetForm = () => {
    // Basic text fields
    setRuleName("");
    setTitleInput("");
    setEditorData("");
    setDescriptionHtmlSource(false);
    setTagsInput("");
    setSkuInput("");
    setShowIsDefault(false);
    // Category dropdown logic
    setSelectedAttributes([]);

    // Title advanced settings
    setTitleAdvanceSetting({
      isRemoveHtml: false,
      isTranslate: false,
      translate_language: "",
      isRephrasing: false,
      rephrasing_limit: "",
    });

    // Description advanced settings
    setDescriptionAdvanceSetting({
      isRemoveHtml: false,
      isTranslate: false,
      translate_language: "",
      isRephrasing: false,
      rephrasing_limit: "",
    });

    // Shortcodes panel
    setShortCodeVisibility({
      name: false,
      title: false,
      tags: false,
      sku: false,
      description: false,
    });

    // Pricing
    setPriceAdjustmentType("increase");
    setRepricing({ type: "FLAT", value: null });
    setPriceRules(priceTemplateFields.length > 0 ? generateDefaultPriceRules(priceTemplateFields) : []);

    // More Field Mapping section
    setMoreFieldMappingData([]);
    setShowMoreMapping(false);

    if (formikRef?.current) {
      formikRef.current.resetForm();
    }

    setEngineKey((prev) => prev + 1);
  };

  const createPayload = (): TITLE_DESCRIPTION => {
    return {
      platform_id: platformId,
      name: finalRuleName,
      title_value_string: titleInput,
      description_value_string: prepareDescriptionValueForSave(editorData, {
        htmlSource: descriptionHtmlSource,
      }),
      tags_value_string: tagsInput,
      sku_value_string: skuInput,
      isDefault: showIsDefault,
      title_processing_config: {
        isRemoveHtml: titleAdvanceSetting.isRemoveHtml,
        isTranslate: titleAdvanceSetting.isTranslate,
        translate_language: titleAdvanceSetting.translate_language,
        isRephrasing: titleAdvanceSetting.isRephrasing,
        rephrasing_limit: titleAdvanceSetting.rephrasing_limit,
      },
      description_processing_config: {
        isRemoveHtml: descriptionAdvanceSetting.isRemoveHtml,
        isTranslate: descriptionAdvanceSetting.isTranslate,
        translate_language: descriptionAdvanceSetting.translate_language,
        isRephrasing: descriptionAdvanceSetting.isRephrasing,
        rephrasing_limit: descriptionAdvanceSetting.rephrasing_limit,
      },
    }
  };
  const formikMappingRefs = useRef<(FormikProps<MORE_MAPPING_FORM_DATA> | null)[]>([]);
  const handleSubmit = (values) => {
  }

  const onSaveChanges = async () => {
    const allValues: MORE_MAPPING_FORM_DATA[] = (moreFieldMappingData ?? [])
      .map((_, index) => formikMappingRefs.current[index]?.values)
      .filter((values): values is MORE_MAPPING_FORM_DATA => values != null);

    const missingMandatoryField = getMissingMandatoryMappingField(
      allValues,
      moreFieldMappingData ?? [],
      MANDATORY_MAPPING_FIELDS
    );
    if (missingMandatoryField) {
      toast.error(
        `Please provide a mapping or default value for the required field: ${missingMandatoryField.display_name}`
      );
      return;
    }

    if (engineState.categoryId === null) {
      toast.error("Please select a category to proceed");
      return;
    }

    const formikValues = formikRef.current?.values;
    if (!formikValues) {
      toast.error("Please fill Product Criteria Form");
      return;
    }

    const hasInvalidCondition = formikValues.productRecipes?.some(
      (item) => item?.checkValue == null || !String(item.checkValue).trim()
    );

    if (hasInvalidCondition) {
      toast.error("Please Add Value for Condition Evaluator");
      setIsSaving(false);
      return; // STOP entire save flow
    }

    if (priceTemplateFields.length > 0) {
      const priceRuleValidationError = getPriceRuleValidationError(priceRules);
      if (priceRuleValidationError) {
        toast.error(priceRuleValidationError);
        return;
      }
    }

    const errors: string[] = [];
    setIsSaving(true);

    try {
      // ==================  Prepare all API payloads ==================
      const templateDesPayload = createPayload();
      const pricePayload = resolveQuicklistPricePayload({
        priceTemplateFields,
        priceRules,
        repricing,
        ruleName: finalRuleName,
        platformId,
      });
      const categoryPayload = {
        platform_id: selectedSecondaryPlatform?.id,
        isDefault: false,
        name: finalRuleName,
        category_data: engineState.categoryId,
        attributes: selectedAttributes,
      };
      const moreMappingSaveEntries = buildMoreMappingSaveEntries(
        allValues,
        moreFieldMappingData ?? []
      );
      const mappingPayloads = moreMappingSaveEntries.map((entry, i) =>
        buildMoreMappingPayload(
          entry,
          finalRuleName,
          i,
          selectedSecondaryPlatform?.id ?? platformId ?? null
        )
      );

      // ================== Run first stage APIs simultaneously ==================
      const firstStageApis = [
        { name: "Title/Description", call: () => dispatch(savePlatformTitleDescriptionTemplateAsync(templateDesPayload)) },
        ...(pricePayload
          ? [{ name: "Price Modifier", call: () => dispatch(savePlatformPriceAsync(pricePayload)) }]
          : []),
        { name: "Category Mapping", call: () => dispatch(postFieldDataAttributesAsync(categoryPayload)) },
        ...mappingPayloads.map((mp, i) => ({
          name: `More Mapping #${i + 1}`,
          call: () => dispatch(createMoreMappingAsync(mp)),
        })),
      ];
      const firstStageResults = await Promise.allSettled(firstStageApis.map((api) => api.call()));

      // Collect IDs and errors
      const apiResponses: Record<string, any> = {}; // store payloads by name
      firstStageResults.forEach((result, i) => {
        const apiName = firstStageApis[i].name;
        if (result.status === "fulfilled") {
          const payload = (result.value as any)?.payload;
          apiResponses[apiName] = payload; // full response
        } else {
          errors.push(`${apiName}: ${result.reason?.message || "Unknown error"}`);
        }
      });
      if (errors.length > 0) {
        toast.error(`Some operations failed:\n${errors.join("\n")}`);
        console.error("Γ¥î Failed APIs:", errors);
        setRuleName(finalRuleName + "-1");
        return; // stop if any first stage API failed
      }

      // ==================  Prepare recipePayload using IDs from first stage ==================
      const priceRes = apiResponses["Price Modifier"];
      const priceTemplateId = pricePayload
        ? Array.isArray(priceRes)
          ? priceRes[0]?.price_template?.id || priceRes[0]?.id
          : priceRes?.id
        : null;

      const recipePayload = {
        platform: selectedSecondaryPlatform?.id,
        name: finalRuleName,
        title_description_template: apiResponses["Title/Description"]?.id,
        price_template: priceTemplateId ?? null,
        category_template: apiResponses["Category Mapping"]?.id,
        check_data_conjunction: formikValues.dataConjunction,
        mapping_data: formikValues?.productRecipes.map((item) => {
          if (item?.checkValue == null || !String(item.checkValue).trim()) {
            toast.error("Please Add Value for Condition Evaluator");
            setRuleName(finalRuleName + "-1");
            return;
          }
          return {
            check_platform_field: item?.checkPlatformField === "" ? checkFormField : item?.checkPlatformField,
            check_operator: item?.checkOperator ?? "CONTAINS",
            check_conjunction: item?.checkConjunction,
            check_value: item?.checkValue,
            mapping_id: null,
          };
        }),
        other_templates: buildOtherTemplateLinks(
          moreMappingSaveEntries,
          mappingPayloads.map((_, index) => apiResponses[`More Mapping #${index + 1}`])
        ),
      };
      // ==================  Run recipePayload API ==================
      const recipeResult = await dispatch(createRecipeAsync(recipePayload));

      if ((recipeResult as any)?.payload?.data?.error) {
        toast.error(`Recipe API error: ${(recipeResult as any).payload?.data?.error}`);
        setRuleName("");
      } else {
        toast.success("All data saved successfully!");
        toast.success("Rule Name is " + finalRuleName);
        resetForm();
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      toast.error("Unexpected error during save process.");
      setRuleName(finalRuleName + "-1");
    } finally {
      setIsSaving(false);
    }
  };


  const isSaveDisabled = !titleInput.trim()

  return (
    <div style={{ paddingTop: '5px' }}>
      {/* Header */}
      <div
        className="d-flex justify-content-between align-items-center px-3 py-2 "
        style={{
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          color: "#333",
          borderBottom: "1px solid #dee2e6",
          fontWeight: 600,
          fontSize: "1.1rem",
          backgroundColor: "rgb(240 240 240)",
        }}
      >
        <span>Quick Way to get your Products Ready for Listing</span>
        {isWrite && (<Button
          size="sm"
          type="submit"
          variant="success"
          disabled={isSaveDisabled || !isUserHavingWriteAccess() || isSaving}
          onClick={onSaveChanges}
        >
          {isSaving ? "Saving..." : "Save Quick Template"}
        </Button>)}
      </div>

      {/* Main White Card */}
      <div style={{ backgroundColor: "rgb(240 240 240)", padding: "1rem" }}>
            {/* ==================== Quick Template Name ==================== */}
            <div style={{ borderRadius: "10px", backgroundColor: "#fff", marginBottom: "1rem" }}>
              <div
                className="border-bottom"
                style={{
                  borderColor: "#dee2e6",
                  padding: "0.75rem 1rem",
                }}
              >
                <h6 className="fw-semibold mb-0"><span className='optional-sm'>Template Name</span>
                </h6>
              </div>

              <div className="px-4 py-3">
                <Form.Group className="mb-0">
                  <Form.Control
                    type="text"
                    placeholder="Enter Template Name"
                    value={ruleName}
                    onChange={(e) => setRuleName(e.target.value)}
                  />
                  <Form.Text className="text-muted">
                    Leaving this empty will auto-generate a Template Name.
                  </Form.Text>
                </Form.Group>
              </div>
            </div>
            {/* ==================== Product Criteria Section ==================== */}
            <div style={{ borderRadius: "10px", backgroundColor: "#fff", marginBottom: "1rem" }} >
            {templateDataLoading ? (
              <div className="d-flex align-items-center justify-content-center py-4">
                <Spinner animation="border" size="sm" variant="primary" />
                <span className="ms-2 text-muted">Loading product fields...</span>
              </div>
            ) : (<>
              <Formik<RECIPE_FORM_DATA>
                innerRef={formikRef}
                initialValues={initialValue1}
                onSubmit={(values, helpers) => { }}
              >
                {({
                  values,
                  handleChange,
                  handleSubmit,
                  setFormikState,
                  setSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>

                    <div
                      className="border-bottom"
                      style={{
                        borderColor: "#dee2e6",
                        padding: "0.75rem 1rem",
                      }}
                    >
                      <h6 className="fw-semibold mb-0"><span className='required-sm'>Which Products you want to list?</span></h6>
                    </div>
                    <div className="px-4 py-3">
                      <div className='row g-3 gx-lg-3 align-items-center mb-2'>
                        {values.productRecipes.length > 1 && (
                          <div className="col-6 col-sm-2">
                            <p className="form-label mb-0">Select Condition</p>
                          </div>
                        )}

                        <div className="col-6 col-sm-3">
                          <p className="form-label mb-0">Select Field To Filter</p>
                        </div>

                        <div className="col-12 col-lg-6">
                          <p className="form-label mb-0">Condition Evaluator</p>
                        </div>
                      </div>
                      <div>
                        {values.productRecipes.map((recipe, recipeIndex) => (
                          <RecipeRuleItem
                            key={'recipeitem' + recipeIndex}
                            formValues={values}
                            handleChange={handleChange}
                            customFieldLoading={false}
                            recipe={recipe}
                            recipeIndex={recipeIndex}
                            setFormikState={setFormikState}
                            setSubmitting={setSubmitting}
                            getLatestRecipesList={() => { }}
                            recipeData={null}
                            recipeDataInDetail={null}
                            platformCustomFields={platformCustomFields}
                            platformNativeFields={platformNativeFields}
                            selectedRowsForDeletion={selectedRowsForDeletion}
                            setSelectedRowsForDeletion={setSelectedRowsForDeletion}
                            checkFormField={checkFormField}
                            isQuickTab={isQuickTab}
                            hideConditionOnSingleRow={true}
                          />
                        ))}
                        {isWrite && (<button
                          type="button"
                          className="btn btn-primary btn-sm mt-2"
                          onClick={() =>
                            setFormikState((pre) => ({
                              ...pre,
                              values: {
                                ...pre.values,
                                dataConjunction: values?.dataConjunction,
                                productRecipes: [
                                  ...pre.values.productRecipes,
                                  {
                                    id: null,
                                    checkConjunction: 'OR',
                                    checkOperator: 'CONTAINS',
                                    checkPlatformField: platformNativeFields[0]?.id + '',
                                    checkValue: '',
                                  },
                                ],
                              },
                            }))
                          }
                        >
                          + Add new
                        </button>)}
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </>)}
            </div>
            {/* ==================== Title & Description Section ==================== */}

            <div style={{ borderRadius: "10px", backgroundColor: "#fff", marginBottom: "1rem" }} >
              <div >
                <div
                  className="border-bottom"
                  style={{
                    borderColor: "#dee2e6",
                    padding: "0.75rem 1rem",
                  }}
                >
                  <h6 className="fw-semibold mb-0 "><span className='required-sm'>Title Description Mapping Rule</span></h6>
                </div>
                <div className="px-4 py-3" >
                  {/* ===== Title Section ===== */}
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "6px" }}>
                      <label className="form-label mb-0">Title</label>
                      {platformLimitations.title.info || platformLimitations.title.max ? (
                        <small className="text-muted text-end ms-3" style={{ maxWidth: '50%' }}>
                          {platformLimitations.title.info ??
                            `Recommended Max Character Limit: ${platformLimitations.title.max}`}
                          {platformLimitations.title.max
                            ? ` (${platformLimitations.title.max - titleInput.length} characters remaining)`
                            : ''}
                        </small>
                      ) : null}
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Customize your Title."
                      onChange={(e) => {
                        const limit = platformLimitations.title.max
                        if (limit && limit > 0 && e.target.value.length > limit) return
                        setTitleInput(e.target.value)
                      }}
                      value={titleInput}
                      maxLength={platformLimitations.title.max ?? undefined}
                    />
                    {/* Shortcodes */}
                    <div className="mt-3">
                      <p className="text-primary fw-bold mb-2">Available Shortcodes</p>
                      {shortCodeVisibility.title ? (
                        <div className="d-flex flex-wrap">
                          {shortCode?.map((item: any) => (
                            <Fragment key={item.id}>
                              <CopyToClipboard text={item.name}>
                                <Button
                                  size="sm"
                                  variant={
                                    copyMarkup["title"] && buttonString === item.name
                                      ? "outline-success"
                                      : "outline-primary"
                                  }
                                  className={`px-3 py-1 border border-1 m-1 ${copyMarkup["title"] && buttonString === item.name
                                    ? "border-success"
                                    : "border-primary"
                                    } rounded text-hover-dark fs-sm-8`}
                                  onClick={() => handleCopyMarkup(item.name, "title")}
                                >
                                  {copyMarkup["title"] && buttonString === item.name ? (
                                    <span className="fs-sm-8">Copied!</span>
                                  ) : (
                                    item.name
                                  )}
                                </Button>
                              </CopyToClipboard>
                            </Fragment>
                          ))}
                          {customItem && renderCustomFieldDropdown("title")}
                        </div>
                      ) : (
                        <span className="spinner-border text-secondary spinner-border-sm ms-2"></span>
                      )}
                    </div>

                    {/* AI Optimization Toggle */}
                    <div className="mt-3">
                      <button
                        type="button"
                        className="btn btn-sm btn-link text-primary fw-bold p-0"
                        onClick={() => setOpenTitleAdvanceConfig(!openTitleAdvanceConfig)}
                      >
                        <i className="bi bi-sliders fw-bold text-primary me-1"></i>AI-Powered Content Optimization
                      </button>
                    </div>

                    {/* Title Advanced Settings */}
                    {openTitleAdvanceConfig && (
                      <div className="row mt-3">
                        <div className="col-3">
                          <div className="form-check form-switch d-flex align-items-center">
                            <label className="text-secondary fw-bold" htmlFor="titleCode">
                              Remove HTML
                            </label>
                            <input
                              id="titleCode"
                              className="form-check-input ms-2"
                              type="checkbox"
                              checked={titleAdvanceSetting.isRemoveHtml}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  isRemoveHtml: ev.target.checked,
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-5">
                          <div className="form-check form-switch d-flex align-items-center">
                            <label className="text-secondary fw-bold" htmlFor="titleTranslate">
                              Translate To Other Language
                            </label>
                            <input
                              id="titleTranslate"
                              className="form-check-input ms-2"
                              type="checkbox"
                              checked={titleAdvanceSetting.isTranslate}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  isTranslate: ev.target.checked,
                                }))
                              }
                            />
                          </div>
                          {titleAdvanceSetting.isTranslate && (
                            <select
                              value={titleAdvanceSetting.translate_language}
                              className="form-select mt-2"
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  translate_language: ev.target.value,
                                }))
                              }
                            >
                              <option value="">Select Language</option>
                              {LANGUAGES_ENUM.map((item) => (
                                <option key={"title" + item} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                          )}
                        </div>

                        <div className="col-4">
                          <div className="form-check form-switch d-flex align-items-center">
                            <label className="text-secondary fw-bold" htmlFor="titleRephrasing">
                              Rephrasing
                            </label>
                            <input
                              id="titleRephrasing"
                              className="form-check-input ms-2"
                              type="checkbox"
                              checked={titleAdvanceSetting.isRephrasing}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  isRephrasing: ev.target.checked,
                                }))
                              }
                            />
                          </div>
                          {titleAdvanceSetting.isRephrasing && (
                            <input
                              placeholder="Enter Character Limit"
                              type="number"
                              className="form-control mt-2"
                              value={titleAdvanceSetting.rephrasing_limit}
                              onChange={(ev) =>
                                setTitleAdvanceSetting((pre) => ({
                                  ...pre,
                                  rephrasing_limit: ev.target.value,
                                }))
                              }
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ===== Description Section ===== */}
                  <div className="mb-3">
                    <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "6px" }}>
                      <label className="form-label mb-0">Description</label>
                      {platformLimitations.description.info || platformLimitations.description.max ? (
                        <small className="text-muted text-end ms-3" style={{ maxWidth: '50%' }}>
                          {platformLimitations.description.info ??
                            `Recommended Max Character Limit: ${platformLimitations.description.max}`}
                          {platformLimitations.description.max
                            ? ` (${remainingDescriptionCharacters} characters remaining)`
                            : ''}
                        </small>
                      ) : null}
                    </div>
                    <DescriptionHtmlEditor
                      value={editorData}
                      onChange={handleDescriptionChange}
                      htmlSource={descriptionHtmlSource}
                      onHtmlSourceChange={setDescriptionHtmlSource}
                      maxCharacters={descriptionLimit}
                      placeholder="Customize your Description or map with Source Store field."
                    />
                  </div>
                  {/* Shortcodes */}
                  <div className="mt-3">
                    <p className="text-primary fw-bold mb-2">Available Shortcodes</p>
                    {shortCodeVisibility.description ? (
                      <div className="d-flex flex-wrap">
                        {shortCode?.map((item: any) => (
                          <Fragment key={item.id}>
                            <CopyToClipboard text={item.name}>
                              <Button
                                size="sm"
                                variant={
                                  copyMarkup["description"] && buttonString === item.name
                                    ? "outline-success"
                                    : "outline-primary"
                                }
                                className={`px-3 py-1 border border-1 m-1 ${copyMarkup["description"] && buttonString === item.name
                                  ? "border-success"
                                  : "border-primary"
                                  } rounded text-hover-dark fs-sm-8`}
                                onClick={() => handleCopyMarkup(item.name, "description")}
                              >
                                {copyMarkup["description"] && buttonString === item.name ? (
                                  <span className="fs-sm-8">Copied!</span>
                                ) : (
                                  item.name
                                )}
                              </Button>
                            </CopyToClipboard>
                          </Fragment>
                        ))}
                        {customItem && renderCustomFieldDropdown("description")}
                      </div>
                    ) : (
                      <span className="spinner-border text-secondary spinner-border-sm ms-2"></span>
                    )}
                  </div>

                  {/* AI Optimization Toggle */}
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-link text-primary fw-bold p-0"
                      onClick={() => setOpenDescriptionAdvanceConfig(!openDescriptionAdvanceConfig)}
                    >
                      <i className="bi bi-sliders fw-bold text-primary me-1"></i>AI-Powered Content Optimization
                    </button>
                  </div>

                  {/* Description Advanced Settings */}
                  {openDescriptionAdvanceConfig && (
                    <div className="row mt-3">
                      <div className="col-3">
                        <div className="form-check form-switch d-flex align-items-center">
                          <label className="text-secondary fw-bold" htmlFor="descCode">
                            Remove HTML
                          </label>
                          <input
                            id="descCode"
                            className="form-check-input ms-2"
                            type="checkbox"
                            checked={descriptionAdvanceSetting.isRemoveHtml}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                isRemoveHtml: ev.target.checked,
                              }))
                            }
                          />
                        </div>
                      </div>

                      <div className="col-5">
                        <div className="form-check form-switch d-flex align-items-center">
                          <label className="text-secondary fw-bold" htmlFor="descTranslate">
                            Translate To Other Language
                          </label>
                          <input
                            id="descTranslate"
                            className="form-check-input ms-2"
                            type="checkbox"
                            checked={descriptionAdvanceSetting.isTranslate}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                isTranslate: ev.target.checked,
                              }))
                            }
                          />
                        </div>
                        {descriptionAdvanceSetting.isTranslate && (
                          <select
                            value={descriptionAdvanceSetting.translate_language}
                            className="form-select mt-2"
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                translate_language: ev.target.value,
                              }))
                            }
                          >
                            <option value="">Select Language</option>
                            {LANGUAGES_ENUM.map((item) => (
                              <option key={"desc" + item} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      <div className="col-4">
                        <div className="form-check form-switch d-flex align-items-center">
                          <label className="text-secondary fw-bold" htmlFor="descRephrasing">
                            Rephrasing
                          </label>
                          <input
                            id="descRephrasing"
                            className="form-check-input ms-2"
                            type="checkbox"
                            checked={descriptionAdvanceSetting.isRephrasing}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                isRephrasing: ev.target.checked,
                              }))
                            }
                          />
                        </div>
                        {descriptionAdvanceSetting.isRephrasing && (
                          <input
                            placeholder="Enter Character Limit"
                            type="number"
                            className="form-control mt-2"
                            value={descriptionAdvanceSetting.rephrasing_limit}
                            onChange={(ev) =>
                              setDescriptionAdvanceSetting((pre) => ({
                                ...pre,
                                rephrasing_limit: ev.target.value,
                              }))
                            }
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ==================== Price Section ==================== */}
            <div style={{ borderRadius: "10px", backgroundColor: "#fff", marginBottom: "1rem" }} >
              <div >
                <div
                  className="border-bottom"
                  style={{
                    borderColor: "#dee2e6",
                    padding: "0.75rem 1rem",
                  }}
                >
                  <h6 className="fw-semibold mb-0">Price Modifier Rule</h6>
                </div>

                <div className="px-4 py-3">
                  <DynamicPriceModifierRule
                    priceRules={priceRules}
                    isLoading={priceFieldsLoading}
                    onChange={handlePriceRuleChange}
                    advancedMode={true}
                    hasPriceDateRows={priceRules.some(rule => rule.isPriceDate)}
                    nativeFields={priceNativeFields}
                    customFields={priceCustomFields}
                    mappingFieldsLoading={mappingFieldsLoading}
                    onMappingOptionChange={handleMappingOptionChange}
                    fallbackUI={
                      <div className="row align-items-center g-3">
                        <div className="col-sm-3 text-sm-center">
                          <p className="form-label mb-0">Adjustment Type</p>
                        </div>
                        <div className="col-sm-3 col-12">
                          <select
                            className="form-select"
                            value={priceAdjustmentType}
                            onChange={handleAdjustmentChange}
                          >
                            <option value="increase">Increase</option>
                            <option value="decrease">Decrease</option>
                          </select>
                        </div>
                        <div className="col-sm-3 col-12 d-flex align-items-center">
                          <label className="form-label mb-0">by</label>
                          <input
                            type="number"
                            className="form-control ms-2"
                            placeholder="Enter value"
                            min={0}
                            step="any"
                            onKeyDown={blockNegativeNumberInput}
                            value={formatLegacyRepricingMagnitudeForInput(repricing.value)}
                            onChange={handleValueChange}
                          />
                        </div>
                        <div className="col-sm-3 col-12">
                          <select
                            className="form-select"
                            value={repricing.type}
                            onChange={handleTypeChange}
                          >
                            <option value="FLAT">Flat Amount</option>
                            <option value="PERCENTAGE">Percent</option>
                          </select>
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>

            {/* ==================== Category Section ==================== */}
            <div style={{ borderRadius: "10px", backgroundColor: "#fff", marginBottom: "1rem" }} >
              <div  >
                <div
                  className="border-bottom"
                  style={{
                    borderColor: "#dee2e6",
                    padding: "0.75rem 1rem",
                  }}
                >
                  <h6 className=" fw-semibold mb-0"><span className='required-sm'>Category Mapping Rule</span></h6>
                </div>

                <div className="px-4 py-3">
                  <CategoryMappingEngine
                    key={`engine-${engineKey}`}
                    selectedSecondaryPlatform={selectedSecondaryPlatform}
                    isEditMode={false}
                    updatingMapData={null}
                    inputAttributesKey={String(engineState.categoryId)}
                    onCategoryChange={setEngineState}
                    onAttributeSelection={(attributes) => setSelectedAttributes(attributes)}
                    nativeFields={platformNativeFields}
                    customFields={platformCustomFields}
                  />
                </div>
              </div> </div>

            {/* More mapping fields Section  */}

            {showMoreMapping && moreFieldMappingData?.map((item, index) => (
              <div style={{ borderRadius: "10px", backgroundColor: "#fff", marginBottom: "1rem" }} >
                <div
                  key={item.id}
                  style={{
                    backgroundColor: "#fcfcfc", borderTopLeftRadius: "10px", borderTopRightRadius: "10px",
                    borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px"
                  }}
                >
                  {/* Card Header */}
                  <div
                    className="d-flex align-items-center justify-content-between"
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      padding: "0.75rem 1rem",
                    }}
                  >
                    <h6
                      className="fw-semibold mb-0"
                      style={{ fontSize: "1rem", letterSpacing: "0.3px" }}
                    >
                      <span className={MANDATORY_MAPPING_FIELDS.includes(item?.api_code) ? 'required-spell' : ''}> {item.display_name} Field Mapping Rule</span>
                    </h6>
                  </div>

                  {/* Card Body */}
                  <div className="px-4 py-3" >
                    <Formik<MORE_MAPPING_FORM_DATA>
                      innerRef={(el) => (formikMappingRefs.current[index] = el)} // assign ref per form
                      initialValues={{
                        name: '',
                        platform_id: platformId ?? null,
                        platform_field: item.id ?? null,
                        mapped_field: null,
                        value: null,
                        value_str: '',
                        isDefault: false,
                        template_data: [
                          {
                            id: null,
                            mapped_field: null,
                            value: null,
                            value_str: '',
                          },
                        ],
                      }}
                      onSubmit={handleSubmit}
                    >
                      {({ values, handleChange, setFieldValue, setFormikState }) => (
                        <Form>
                          <div style={{ marginLeft: "10px" }}>
                            <InputAttributes2
                              categoryAttributes={item}
                              paltformId={selectedSecondaryPlatform?.id}
                              values={values}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              setFormikState={setFormikState}
                              moreMappingData={item.moreMappingData || null}
                              getLatestMoreMappingDataList={() => console.log('refresh')}
                              resetTrigger={resetTrigger}
                              closeModal={closeModal}
                              openAddNewAttributeValueModal={openAddNewAttributeValueModal}
                              setOpenAddNewAttributeValueModal={setOpenAddNewAttributeValueModal}
                              nativeFields={platformNativeFields}
                              customFields={platformCustomFields}
                            />
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            ))}
      </div>
    </div >
  );
};


export default CreateQuickListTab;
